import {css, Typography} from '@mui/material';
import {LightHierarchyFilter, LightSelectFilter, LightTextFilter, useDrpCauseBackground} from '@wallaby-ui/document';
import React, {useCallback} from 'react';

type Props = {
  label: string;
  onLabelChange: (value: string | null) => void;
  selectedType: string | null;
  onTypeChange: (value: string | null) => void;
  selectedCauses: string[];
  onCausesChange: (value: string[] | null) => void;
  selectedInterventions: string[];
  onInterventionsChange: (value: string[] | null) => void;
  drpParams: {
    drp_type: any;
    drp_causes: any;
    drp_plannedInterventions: any;
  };
  error?: string;
  isSubmitting: boolean;
};

export const CombinationForm: React.FC<Props> = ({
  label,
  onLabelChange,
  selectedType,
  onTypeChange,
  selectedCauses,
  onCausesChange,
  selectedInterventions,
  onInterventionsChange,
  drpParams,
  error,
  isSubmitting,
}) => {
  const getDrpCauseBackground = useDrpCauseBackground();
  const getDrpCauseBackgroundColor = useCallback(
    (cause: any) =>
      css({
        backgroundColor: getDrpCauseBackground(cause),
      }),
    [getDrpCauseBackground]
  );

  return (
    <>
      <LightTextFilter
        wrapperWidth={'100%'}
        inputWidth={'100%'}
        config={{
          name: 'combinationLabel',
          ui: {label: 'hospitalization.detail.phRec.combination.label'},
        }}
        value={label}
        onChange={onLabelChange}
      />

      <LightSelectFilter
        maxWidth='100%'
        {...drpParams.drp_type}
        value={selectedType}
        onChange={onTypeChange}
        error={error && !selectedType ? error : undefined}
        disabled={isSubmitting}
        optional={false}
      />

      <LightHierarchyFilter
        maxWidth='100%'
        {...drpParams.drp_causes}
        defaultIsExpanded
        value={selectedCauses}
        onChange={onCausesChange}
        chipCss={getDrpCauseBackgroundColor}
        error={error && selectedCauses.length === 0 ? error : undefined}
        disabled={isSubmitting}
        optional={false}
      />

      <LightSelectFilter
        maxWidth='100%'
        {...drpParams.drp_plannedInterventions}
        value={selectedInterventions}
        onChange={onInterventionsChange}
        error={error && selectedInterventions.length === 0 ? error : undefined}
        disabled={isSubmitting}
        optional={false}
      />

      {error && (
        <Typography variant='value' style={{color: 'var(--dlThemeError)', fontSize: 12}}>
          {error}
        </Typography>
      )}
    </>
  );
};
